// @flow
import { connect } from 'react-redux';

import MemberPageDetail from 'components/page/MemberPageDetail';
import type { StateProps } from 'components/page/MemberPageDetail';
import type { StateType } from 'types/Actions';

export default connect(
  (state: StateType): StateProps => ({
    userPref: state.userState.userPref
  })
)(MemberPageDetail);
